module.exports = __webpack_public_path__ + "static/media/user.7541dd64.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/user.png
 ** module id = 212
 ** module chunks = 0
 **/